export default "__VITE_ASSET__CvhYskX1__"